import { useState } from 'react';
import './FormTemperatureBox.scss';
import icon_plus from '../../assets/icon_plus.svg';
import icon_minus from '../../assets/icon_minus.svg';

const FormTemperatureBox = ({ defaultValue, updateField, label }) => {
  const [value, setValue] = useState(defaultValue);

  const updateTemperature = (e) => {
    if (e.target.getAttribute('action') === '+') {
      setValue(value + 1);
      updateField(value + 1);
    } else {
      setValue(value - 1);
      updateField(value - 1);
    }
  };

  return (
    <div
      className="form-temperature-box"
      style={{ '--icon-plus': `url(${icon_plus})`, '--icon-minus': `url(${icon_minus})` }}
    >
      <div className="temperature-box-header">{label}</div>
      <div className="temperature-box">
        <div className="selected-temperature">{value}</div>

        <div className="temperature-adjustments">
          <div className="increment-temp">
            <input type="button" action="+" onClick={updateTemperature} />
          </div>
          <div className="decrement-temp">
            <input type="button" action="-" onClick={updateTemperature} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormTemperatureBox;
